export enum EventENUMV2 {
  APP_CRASH = "app crash",
  CLICKED_BOOK_NOW = "click book now",
  CLICKED_DESTINATION_PROPERTY = "click featured destination",
  CLICKED_FEATURED_PROPERTY = "click featured property",
  CLICKED_NEARBY_PROPERTIES = "click explore nearby properties",
  CLICKED_SAVE_PROPERTY = "click to save property",
  CLICKED_SHARE_PROPERTY = "share property",
  CLICK_SUBMIT_PAYMENT = "click submit payment",
  CLICK_SET_UP_ACCOUNT = "click set up account",
  COMPLETE_REGISTRATION = "complete registration",
  COMPLETE_SIGN_IN = "complete sign in",
  ENTER_PROMOCODE = "enter promocode",
  REQUEST_REGION = "request region",
  RESET_USER = "reset user",
  VIEW_BOOKING_DETAILS_PAGE = "view booking details page",
  VIEW_CHECKOUT_CONFIRMATION_PAGE = "view checkout confirmation page",
  VIEW_STAGED_PAYMENT_CONFIRMATION_PAGE = "view staged payment confirmation page",
  VIEW_CHECKOUT_DETAILS_PAGE = "view checkout traveler details page",
  VIEW_CHECKOUT_PAYMENT_PAGE = "view checkout payment page",
  CLICK_PAYMENT_TYPE = "click payment type",
  CLICK_CHANGE_DATES = "click change dates",
  VIEW_HOME_PAGE = "view home page",
  VIEW_HOST_LANDING_PAGE = "view host landing page",
  VIEW_LOGIN_PROMPT = "view login prompt",
  VIEW_REGISTRATION_PROMO = "view registration promo",
  VIEW_PRICE_BREAKDOWN_POPOVER = "view price breakdown popover",
  VIEW_PROPERTY_DETAILS_PAGE = "view property details page",
  VIEW_SPRING_BREAK_DEALS_PAGE = "view spring break deals page",
  VIEW_SEARCH_RESULTS_PAGE = "view search results page",
  CLICK_PROPERTY_ON_SEARCH_RESULT_PAGE = "click property on search result page",
  WEBSITE_ERROR = "website error page",
  CLICK_NEARBY_DESTINATION = "click nearby destination",
  CLICK_SIMILAR_PROPERTY = "click similar property",
  CLICK_IMAGES = "click images",
  EMAIL_VERIFICATION = "email verification",
  CLICK_SUBMIT_NPS = "click submit nps",
  CLICK_SUBMIT_NPS_FEEDBACK = "click submit nps feedback",
  CLICK_TOTAL_TRIP_SAVING = "click total trip savings",
  CLICK_PRICE_RANGE = "click price range",
  CLICK_POPULAR_CHOICES = "click popular choices",
  BOOKING_ERROR = "booking error",
  CLICK_REFERRAL = "click referral",
  CLICK_VIATOR = "click viator",
  FAQ_VIEWED = "faq viewed",
  BLOG_VIEWED = "blog viewed",
  VIEW_BLOG = "view blog",
  VIEW_REVIEWS_PAGE = "view reviews page",
  CLICK_LEAVE_REVIEW = "click leave a review",
  CLICK_ID_VERIFICATION = "click id verification",
  VIEW_REFERRALS_PAGE = "view referrals page",
  VIEW_PENDING_ID_VERIFICATION_PAGE = "view pending id verification page",
  VIEW_ABOUT_US_PAGE = "view about us page",
  CLICK_REMOVE_MAP_BOUNDARY = "click remove map boundary",
  CLICK_PRICE = "click price",
  CLICK_DOT = "click dot",
  CLICK_MAP_CARD = "click map card",
  CLICK_VIEW_CARD_LIST = "click view card list",
  DATE_SELECTION = "date selection",
  GUEST_SELECTION = "guest selection",
  UNIT_FILTER_APPLIED = "unit filter applied",
  BLOG_CLICKED_DESKTOP = "Blog Clicked",
  BLOG_CLICKED_MOBILE = "blog Clicked",
  // events for RBO properties
  RBO_BOOKING_RECEIVED = "rbo booking received",
  RBO_BOOKING_CANCELED = "rbo booking canceled",
  // cancellation booking flow events
  CLICK_CHANGE_BOOKING = "click change booking",
  CLICK_MODIFY_BOOKING = "click modify booking",
  CLICK_CANCEL_BOOKING = "click cancel booking",
  CLICK_CHAT_WITH_HOST = "click chat with host",
  TRAVELLER_INFO_COMPLETE = "traveller info complete",
  GUEST_CHECKOUT_STARTED = "guest checkout started",
  INSURANCE_OPTION_SELECTED = "insurance option selected",
  PAYMENT_TIMING_CHOSEN = "payment timing chosen",
  STAGED_PAYMENT_CHOICE = "staged payment choice",

  // my booking flow events
  CLICK_START_EXPLORING_BUTTON = "click start exploring button",
  CLICK_PENDING_BOOKINGS = "click pending bookings",
  CLICK_UPCOMING_BOOKINGS = "click upcoming bookings",
  CLICK_PAST_BOOKINGS = "click past bookings",
  CLICK_CANCELLED_BOOKINGS = "click cancelled bookings",
  CLICK_BOOKING_CARD_DETAILS = "click booking card details",
  CLICK_REBOOK = "click rebook",
  CLICK_WRITE_A_REVIEW = "click write a review",

  // My Bookings - Booking Details page events
  CLICK_TOTAL_COST_PANEL = "click total cost panel",
  CLICK_ADDRESS = "click address",
  CLICK_CALL = "click call",
  CLICK_EMAIL = "click email",
  CLICK_ADD_INSURANCE = "click add insurance",

  CLICK_DOWNLOAD = "click download",

  // events for precision pricing
  SHOW_PRECISION_PRICING = "show precision pricing",
  CLICK_AIRBNB_LINK = "click airbnb link",
  CLICK_VRBO_LINK = "click vrbo link",

  // events for pdp
  PDP_DESCRIPTION_CLICK = "pdp description click",
  PDP_THINGS_TO_KNOW_CLICK = "pdp things to know click",
  PDP_CANCELLATION_POLICY_CLICK = "pdp cancellation policy click",
  PDP_AMENITIES_CLICK = "pdp amenities click",
  // mixpanel alias for PDP_ABOUT_HOST_CLICK => click ask question to host
  PDP_ABOUT_HOST_CLICK = "pdp about host click",
  PDP_GUEST_REVIEWS_CLICK = "pdp guest reviews click",
  VIEW_REVIEWS = "view reviews",
  CLICK_REVIEW_SHOW_MORE = "click review show more",

  // events for confirmation/thankyou page
  NOTIFY_GUESTS = "click notify guests on email address submit",
  SAVE_TO_CALENDAR = "click save to calendar",
  DOWNLOAD_PRINT = "click download receipt",
  GET_THE_APP = "click get the app",
  CONTACT_US = "click contact us",
  VERIFY_NOW = "click verify now", // for booking page and thankyou page

  CLICK_AIRBNB_PREQUOTE = "click airbnb prequote", // On getting Prequote response
  VIEW_AI_SUMMARY = "view ai summary", // fired when AI summary block enters in viewport

  // price drop events
  CLICK_PRICE_DROP_WATCH = "click price drop watch",
  CLICK_PRICE_DROP_WATCH_CREATED = "click price drop watch created",
  CLICK_PRICE_DROP_WATCH_REMOVED = "click price drop watch removed",
  CLICK_VIEW_WATCHLIST_PROPERTY = "click view watchlist property",
  CLICK_PRICE_DROP_WATCH_ERROR = "price drop watch error",

  // soft login events
  VIEW_SOFT_LOGIN_PROMPT = "view softlogin prompt",
  COMPLETE_SOFT_LOGIN = "complete softlogin",
  EXIT_SOFT_LOGIN = "exit softlogin",

  // multi unit detail page events
  VIEW_MULTI_UNIT_DETAIL_PAGE = "view multi unit detail page",
  CLICK_MULTI_UNIT_DETAIL_CARD = "click multi unit detail card",

  CLICK_OPEN_FILTERS = "click open filters",
  CLICK_OPEN_SEARCH = "click open search",

  //watchlist page events
  VIEW_WATCHLIST_PAGE = "view watchlist page",
  CLICK_REMOVE_FAVORITE = "click remove favorite",
  CLICK_REMOVE_PRICE_ALERT = "click remove price alert",
  CLICK_CONFIRM_REMOVAL = "click confirm removal",

  CLICK_LEARN_MORE_LINK = "click learn more link",
  CLICK_PRICE_INFO_ICON = "click price info icon",

  TA_LINK_GENERATION_CLICK = "ta link generation click",
  TA_LINK_GENERATED = "ta link generated",
  TA_STRIPE_ACCOUNT_CREATION_CLICK = "ta stripe account creation click",
}

export enum UserProfilePropertiesV2 {
  DATE_OF_LAST_SEARCH = "date of last search",
  ID_OF_LAST_PROPERTY_VIEWED = "id of last property viewed",
  LOCATION_OF_LAST_SEARCH = "location of last search",
  NUMBER_OF_BOOK_BUTTON_CLICKS = "num of book button clicks",
  NUMBER_OF_DETAIL_PAGE_VIEWS = "num of property details page views",
  NUMBER_OF_PROPERTIES_FAVORITED = "num of properties favorited",
  TOTAL_NUMBER_OF_SEARCH_RESULTS_PAGE_VIEWS = "total num of search results page views",
  VERIFIED_EMAIL = "$Verified_email",
  GVR_USER = "gvr user",
  GVR_USER_FIRST_VISITED_DATE = "gvr user first visited date",
  TA_AGENT_ID = "ta agent id",
  TA_AGENT_EMAIL_ID = "ta agent email id",
}

export enum PageOriginEnumV2 {
  "/" = "home page",
  "/about" = "about us page",
  "/blog" = "blog landing page",
  "/contact-us" = "contact page",
  "/detail" = "property details page",
  "/faq" = "faqs page",
  "/privacy" = "privacy page",
  "/property-managers" = "host landing page",
  "/sitemaps" = "sitemap page",
  "/terms" = "terms page",
  "/vacation-rentals" = "search results page",
}

export enum EventENUM {
  ABOUT_US_CLICKED = "About Us Clicked",
  PROMO_CODE_CLICKED = "Promo Code Clicked",
  BILLING_INFORMATION = "Billing Information",
  BLOG_CLICKED_DESKTOP = "Blog Clicked",
  BLOG_CLICKED_MOBILE = "blog Clicked",
  BOOKING_ERROR = "Booking Error",
  BOOKING_FLOW_ERR = "bookingFlowErr",

  BOOKING_STORE_INVALID_PREQUOTE_REQUEST = "Booking Store - Invalid Prequote Request",
  BOOKING_STORE_PREQUOTE_ERROR = "Booking Store - Prequote Error",
  BOOKING_STORE_PREQUOTE_ERROR_DURING_TESTING = "Booking Store - Prequote Error During Testing",
  BOOKING_STORE_SUCCESS = "Booking Store - Success",
  BOOKING_TRACKER = "Booking tracker",

  BOOK_NOW_OR_CONTINUE_BOOKING_CLICKED = "Book Now or Continue Booking Clicked",
  CALENDER = "Calender",
  CLICKED_SHARE_BUTTON = "Clicked Share Button",

  COMPLETED_BOOKING = "Completed booking",

  BOOKING_SURVEY = "Booking Survey",

  CONTACT_US_FORM_SUBMISSION = "Contact Us Form Submission",

  CONTINUE_WITH_EMAIL_FOR_LOGIN = "Continue With Email - For Login",
  EMAIL_VERIFICATION = "Email verification",

  FACEBOOK_LINK_CLICKED = "Facebook Link Clicked",
  FAQS_CLICKED = "FAQs Clicked",
  INSPIRATION_PRESSED = "INSPIRATION_PRESSED",

  INSTAGRAM_LINK_CLICKED = "Instagram Link Clicked",
  INTERESTED_IN_PROPERTY_PICTURES = "INTERESTED_IN_PROPERTY_PICTURES",
  LANDING_PAGE = "Landing Page",
  LINKEDIN_LINK_CLICKED = "Linkedin Link Clicked",

  LIST_YOUR_PROPERTY_FORM_SUBMITTED = "List your property form submited",
  LOGIN_WITH_EMAIL = "Login With Email",
  LOGOUT = "Logout",

  MAP_MARKER_CLICKED = "Map Marker Clicked",
  PAY_NOW = "Pay now",
  PERMANENTLY_DELETE_PROFILE = "Permanently Delete Profile",
  PINTEREST_LINK_CLICKED = "Pinterest Link Clicked",
  PREQUOTE_TIMEOUT_ERR = "Prequote Timeout Error",
  PROFILE_UPDATE = "Profile Update",
  PROMOCODE_APPPLIED = "Promocode Applied",
  PROMOCODE_REMOVED = "Promocode Removed",
  RECOMMENDED_STAYS = "Recommended stays",
  REFUNDABLE_BOOKING_SELECTED = "Refundable booking selected",

  SAVE_TO_FAVOURITES = "Save to Favorites",
  SEARCH_CLICKED = "Search Clicked",
  SEARCH_PAGE_RESULT = "Search Page Result",
  SESSION_CLOSED = "Session closed",

  SIGNUP_INITIATE = "Signup Initiate",
  SIGNUP_LINK_CLICKED = "Signup Link Clicked",
  SITEMAP_CLICKED = "Sitemap Clicked",
  SKIP_MORE_GUESTS_SUBMISSION = "Skip More Guests Submission",
  GOOGLE_SSO_CLICKED = "Google SSO Clicked",

  TOTAL_PAYMENT = "Total payment",

  TWITTER_LINK_CLICKED = "Twitter Link Clicked",
  TIKTOK_LINK_CLICKED = "Tiktok Link Clicked",

  VIEW_PROPERTY_DETAIL_SCREEN = "View property detail screen",
  WEB_SESSION_END = "Web Session end",

  SHOW_PRECISION_PRICING = "Show Precision Pricing",
}
